import { useEffect } from 'react'
import { UNITED_STATES, CANADA, KNOWN_COUNTRIES, MEXICO } from 'utils/constants'
import { useProgramContext } from 'providers/programProvider'
import { actions } from 'providers/programProvider/location/actions'

import useAxios from 'axios-hooks'

export const useCountryCodes = () => {
  const [state, dispatch] = useProgramContext()
  const [{ data, loading, error }] = useAxios(
    { url: 'country-codes' },
    { manual: !!state?.countries }
  )

  useEffect(() => {

    if (!state?.countries && data) {
      // Set USA, CA and MX as the first three countries
      const { usa, canada, rest } = data.reduce((acc, country) => {
        if ([...KNOWN_COUNTRIES, MEXICO].indexOf(country.iso2) > -1) {
          if (country.iso2 === UNITED_STATES) {
            acc.usa = country
          } else if (country.iso2 === CANADA) {
            acc.canada = country
          } else {
            acc.rest.push(country)
          }
        }
        return acc
      }, { usa: null, canada: null, mexico: null, rest: [] })
      dispatch(actions.setCountries([usa, canada, ...rest]))
    }
  }, [data])

  return {
    countryList: state?.countries,
    loading,
    error,
  }
}
